<template>
  <div class="leyend-p" v-if="legendHtml" v-html="legendHtml"></div>
</template>

<script>
import { renderPrismicContent } from '../helpers/prismicHelpers';

export default {
  name: 'LeyendComponent',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    legendHtml() {
      const legendArray = this.sliceData?.primary?.legend;
      if (!legendArray || !Array.isArray(legendArray) || legendArray.length === 0) {
        return '';
      }
      return renderPrismicContent(legendArray);
    }
  }
};
</script>